import { SortOptions } from './CommonSortOptions';
import { CRASSSortOptions } from './CrassSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';


export const tableWithCRASSSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'workbooks': CRASSSortOptions.downstreamWorkbookCount,
  'datasources': CRASSSortOptions.downstreamDataSourceCount
};